<template>
  <Link :href="item.url" class="category-link grid-x align-middle menu-link-body" tabindex="0" @click="handleTagLinkClick">
    <i v-if="icon" class="icon margin-right-xs" :class="icon"></i>

    <span class="category-text">{{ item.text }}</span>
  </Link>
</template>

<script setup>
import { computed } from 'vue';
import Link from '../common/Link';
import { tagNavLinkClick } from '#shared/features/analytics/navigationTags';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  position: {
    type: Number,
    default: 1,
  },
});
const envProps = useEnvProps();
const pageData = usePageData();
const navViewType = useNavViewType();

const { context } = pageData.navigation;
const isMcom = envProps.isMcom;
const iconMap = {
  stores: 'location-pin',
  deals: 'tag',
  lists: 'list',
  gift_registry: 'registry-box',
  gift_cards: 'gift-card',
  order_tracking: 'order-history',
  earn_star_rewards: 'star-rewards-red-large',
  star_rewards: 'star-rewards-red-large',
};
const icon = computed(() => {
  const { text = '' } = props.item;
  const iconKey = text.replace(/ /g, '_').toLowerCase();

  return iconMap[iconKey] || '';
});

const viewType = computed(() => navViewType.viewType);

function handleTagLinkClick() {
  const { text = '', tracking = {} } = props.item;

  if (isMcom) {
    tagNavLinkClick(
      isMcom,
      {
        context: context.value,
        topCategoryName: '',
        pos: props.position,
        col: 1,
        categoryId: '',
        clickableElement: text,
        tracking,
      },
      viewType.value,
      { isShopAll: true },
    );
  }
}
</script>
